import React from "react";

// Mirrors WhatsApp's own wa.me landing page: brand mark, the message that will
// be sent, then the two ways to send it.
//
// Only reached by verify contests configured without a redirect url; the ones
// with one bypass this and navigate the top window straight to WhatsApp.
const FLEXI_LOGO = "https://app.flexifunnels.com/images/newlatestlogo2.png";

function VerifyPopup({ isOpen, onClose, phone, message }) {
  if (!isOpen) return null;

  const digits = String(phone || "").replace(/\D/g, "");
  const text = encodeURIComponent(message || "VERIFY");

  // The app deep link falls back to wa.me, which itself redirects to the app on
  // mobile and offers the web client on desktop.
  const appUrl = `https://wa.me/${digits}?text=${text}`;
  const webUrl = `https://web.whatsapp.com/send?phone=${digits}&text=${text}`;

  const openAndClose = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
    if (onClose) onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Verify on WhatsApp"
    >
      <div className="relative w-full max-w-md rounded-2xl bg-white p-6 text-center shadow-2xl sm:p-8">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-3 top-3 rounded-full p-1.5 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600"
        >
          <svg
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          >
            <path d="M5 5l10 10M15 5L5 15" />
          </svg>
        </button>

        <img
          src={FLEXI_LOGO}
          alt="FlexiFunnels"
          className="mx-auto h-10 w-auto object-contain"
        />

        <h2 className="mt-5 text-xl font-semibold text-gray-900">Verify</h2>

        <p className="mt-2 text-sm leading-5 text-gray-500">
          Send us this message on WhatsApp to verify your entry.
        </p>

        {/* the message exactly as it will arrive */}
        <div className="mt-5 rounded-lg bg-gray-100 px-4 py-3 text-base tracking-wide text-gray-600">
          {message || "VERIFY"}
        </div>

        <button
          type="button"
          onClick={() => openAndClose(appUrl)}
          className="mt-6 w-full rounded-full bg-[#25D366] px-6 py-3 text-base font-medium text-black transition hover:bg-[#1eb855]"
        >
          Open app
        </button>

        <button
          type="button"
          onClick={() => openAndClose(webUrl)}
          className="mt-3 w-full rounded-full border border-gray-300 px-6 py-3 text-base font-medium text-gray-900 transition hover:bg-gray-50"
        >
          Continue to WhatsApp Web
        </button>
      </div>
    </div>
  );
}

export default VerifyPopup;
